"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const analytics_package_1 = __importDefault(require("@alcumus/analytics-package"));
const CopyDashboardModal_1 = require("../Modals/CopyDashboardModal");
const useStyles = (0, core_1.makeStyles)(() => ({
    buttonBase: {
        borderRadius: 100,
        padding: '6px 16px',
    },
    buttonText: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h6,
    },
}));
function CopyDashboardButton({ t }) {
    const classes = useStyles();
    const setCopyDashboardModalVisible = (0, recoil_1.useSetRecoilState)(CopyDashboardModal_1.copyDashboardModalVisibleState);
    const onClick = () => {
        setCopyDashboardModalVisible(true);
        analytics_package_1.default.getInstance().trackWithCategory('Dashboards', 'Copied a dashboard');
    };
    return (react_1.default.createElement(components_1.Button, { "aria-label": t('duplicateDashboard', { ns: 'AriaLabels' }), uppercase: false, rounded: true, className: classes.buttonBase, size: "small", onClick: onClick, "data-testid": "copy-dashboard-button" },
        react_1.default.createElement(components_1.Text, { center: true, className: classes.buttonText }, t('duplicateDashboardButton', { ns: 'translation' }))));
}
exports.default = (0, react_i18next_1.withTranslation)(['translation', 'AriaLabels'])(CopyDashboardButton);
